import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReceiptTemplate } from '../models/receipt-template.model';

@Component({
  selector: 'app-select-print-template-modal',
  templateUrl: './select-print-template-modal.component.html',
  styleUrls: ['./select-print-template-modal.component.scss'],
})
export class SelectPrintTemplateModalComponent implements OnInit {

  /** All active JOB_CARD templates to display for selection. */
  @Input() templates: ReceiptTemplate[] = [];

  public selectedTemplateId = '';

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    // Pre-select the global default; fall back to the first active template.
    const defaultTemplate =
      this.templates.find(t => t.isGlobalDefault) ?? this.templates[0];
    if (defaultTemplate) {
      this.selectedTemplateId = defaultTemplate.id;
    }
  }

  select(id: string): void {
    this.selectedTemplateId = id;
  }

  confirm(): void {
    if (this.selectedTemplateId) {
      this.activeModal.close(this.selectedTemplateId);
    }
  }

  cancel(): void {
    this.activeModal.dismiss();
  }
}
